import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Subcategories, SubcategoriesAddPayload, SubcategoriesEditPayload } from './subcategories.interface';
import { catchError, map, throwError } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class SubcategoriesService {
    private token!: string;
    private basePath = environment.interop.basePath;

    private listUrl =
        this.basePath +
        environment.interop.bulevart.nomenclatoare.subcategorii.list;

    public listDTUrl =
        this.basePath +
        environment.interop.bulevart.nomenclatoare.subcategorii.listDT;

    private findURL =
        this.basePath +
        environment.interop.bulevart.nomenclatoare.subcategorii.find;

    private storeURL =
        this.basePath +
        environment.interop.bulevart.nomenclatoare.subcategorii.store;

    private updateUrl =
        this.basePath +
        environment.interop.bulevart.nomenclatoare.subcategorii.update;

    private deleteUrl =
        this.basePath +
        environment.interop.bulevart.nomenclatoare.subcategorii.delete;

    private listActiveUrl =
        this.basePath +
        environment.interop.bulevart.nomenclatoare.subcategorii
            .listActive;

    private listPublicUrl =
        this.basePath +
        environment.interop.bulevart.nomenclatoare.subcategorii
            .listPublic;

    private listByCategoryUrl =
        this.basePath +
        environment.interop.bulevart.nomenclatoare.subcategorii
            .listByCategory;

    private changeStatusActiveUrl =
        this.basePath +
        environment.interop.bulevart.nomenclatoare.subcategorii
            .active;

    private changeStatusPublicUrl =
        this.basePath +
        environment.interop.bulevart.nomenclatoare.subcategorii
            .public;

    private moveUpUrl =
        this.basePath +
        environment.interop.bulevart.nomenclatoare.subcategorii
            .moveUp;

    private moveDownUrl =
        this.basePath +
        environment.interop.bulevart.nomenclatoare.subcategorii
            .moveDown;

    private httpOptions: any;

    constructor(private http: HttpClient) { }

    getListDT() {
        return this.http.get(this.listDTUrl, this.httpOptions);
    }

    findEntry(id: number) {
        return this.http.post(this.findURL + id, this.httpOptions);
    }

    storeEntry(payload: SubcategoriesAddPayload) {
        return this.http.post(this.storeURL, payload, this.httpOptions);
    }

    updateEntry(payload: SubcategoriesEditPayload) {
        return this.http.put(this.updateUrl, payload, this.httpOptions);
    }

    deleteEntry(id: number) {
        return this.http.delete(this.deleteUrl + id, this.httpOptions);
    }

    getListActive() {
        return this.http
            .get<{ errors: boolean; data: Subcategories[]; status_code: number }>(
                this.listActiveUrl
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({
                        id: item.id,
                        name: item.title,
                    }))
                ),
                catchError((error) => {
                    console.error('Error in get subcategories:', error);
                    return throwError(error);
                })
            );
    }

    getListPublic() {
        return this.http.get(this.listPublicUrl, this.httpOptions);
    }

    getListByCategory(id_category: number) {
        return this.http
            .get<{ errors: boolean; data: Subcategories[]; status_code: number }>(
                this.listByCategoryUrl + id_category
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({
                        id: item.id,
                        name: item.title,
                    }))
                ),
                catchError((error) => {
                    console.error('Error in get subcategories:', error);
                    return throwError(error);
                })
            );
    }

    changeStatusActive(id: number) {
        return this.http.put(this.changeStatusActiveUrl + id, {}, this.httpOptions);
    }

    changeStatusPublic(id: number) {
        return this.http.put(this.changeStatusPublicUrl + id, {}, this.httpOptions);
    }

    updatePosition(id: number, index: number) {
        if (index === 1) {
            // Position +1
            return this.http.put(this.moveUpUrl + id, {}, this.httpOptions);
        } else {
            // Position -1
            return this.http.put(this.moveDownUrl + id, {}, this.httpOptions);
        }
    }

    setToken(token: string) {
        this.token = token;
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: `Bearer ${this.token}`,
            }),
        };
    }
}
